import React from 'react';

import PropTypes from 'prop-types';

const BlueBoxBody = ({ children }) => {
    return (
        <p className="blue-box-body">
            { children }
        </p>
    );
};

BlueBoxBody.propTypes = {
    children: PropTypes.node,
};

export default BlueBoxBody;
